import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});

export const downloadInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

downloadInstance.defaults.headers.common = {};

export const setToken = token => {};

export default axiosInstance;
